(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (factory((global.dpd = global.dpd || {})));
}(this, (function (exports) { 'use strict';

    function EventDispatcher() {
        this.listenersByType = {};
    }

    Object.assign(EventDispatcher.prototype, {
        addEventListener: function (type, handler) {
            var listeners = this.getListenersForType(type);
            this.addUnique(listeners, handler);
        },

        removeEventListener: function (type, handler) {
            var listeners = this.getListenersForType(type);
            this.removeItemFromArray(handler, listeners);
        },

        removeItemFromArray: function (item, array) {
            var index = array.indexOf(item);
            if (index >= 0) {
                array.splice(index, 1);
            }
        },

        addUnique: function (array, item) {
            if (this.arrayDoesNotContain(array, item)) {
                array.push(item);
            }
        },

        arrayDoesNotContain: function (array, item) {
            return array.indexOf(item) < 0;
        },

        hasListener: function (type) {
            return this.listenersByType[type] !== undefined && this.listenersByType[type].length > 0;
        },

        getListenersForType: function (type) {
            if (this.listenersByType[type] === undefined) {
                this.listenersByType[type] = [];
            }
            return this.listenersByType[type];
        },

        dispatchEvent: function (event) {
            var listeners = this.getListenersForType(event.type);
            listeners.forEach(this.callHandler.bind(this, event));
        },

        callHandler: function (event, handler) {
            handler(event);
        }
    });

    function AddEventCommand(dispatcher, type, handler) {
        this.eventDispatcher = dispatcher;
        this.type = type;
        this.handler = handler;
    }
    Object.assign(AddEventCommand.prototype, {
        execute: function () {
            this.eventDispatcher.addEventListener(this.type, this.handler);
        },
        undo: function () {
            this.eventDispatcher.removeEventListener(this.type, this.handler);
        }
    });

    function EventMap() {
        this.commands = [];
        this.groups = [];
    }
    Object.assign(EventMap.prototype, {
        add: function (eventDispatcher, type, handler) {
            var command = new AddEventCommand(eventDispatcher, type, handler);
            command.execute();
            this.commands.push(command);

            return command;
        },

        addMultiple: function (eventDispatcher, types, handler) {
            //TODO should this return a group?
            types = this.typeStringToArray(types);
            var commands = types.map(function (type) {
                return this.add(eventDispatcher, type, handler);
            }.bind(this));

            return commands;
        },

        addTo: function (eventDispatcher, typeHandlerMap) {
            var commands = [];

            for (var type in typeHandlerMap) {
                var handler = typeHandlerMap[type];
                commands.push(this.add(eventDispatcher, type, handler));
            }

            return commands;
        },

        addMultipleTo: function (eventDispatcher, typeHandlerMap) {
            var commands = [];
            for (var typesString in typeHandlerMap) {
                var types = this.typeStringToArray(typesString);
                var handler = typeHandlerMap[typesString];

                for (var i = 0; i < types.length; i++) {
                    commands.push(this.add(eventDispatcher, types[i], handler));
                }
            }

            return commands;
        },

        remove: function (command) {
            command.undo();
            var index = this.commands.indexOf(command);
            this.commands.splice(index, 1);
        },

        removeMultiple: function (commands) {
            commands.forEach(this.remove.bind(this));
        },

        /*
         * @types {String} whitespace separated string of event types
         * "click mouseup touchstart"
         *
         * @eventDispatcher {EventDispatcher}
         * @handler {Function}
         */
        once: function (types, eventDispatcher, handler) {
            types = this.typeStringToArray(types);
            var commands;

            var wrappedHandler = function callHandlerAndRemove(event) {
                handler(event);
                this.removeMultiple(commands);
            }.bind(this);

            //The argument/parameter order of this.add prevents it being used directly
            //Inline this function so it is not exposed
            var addListener = function addListener(eventDispatcher, handler, type) {
                return this.add(eventDispatcher, type, handler);
            }.bind(this, eventDispatcher, wrappedHandler);

            commands = types.map(addListener);

            return commands;
        },

        enableAll: function () {
            var commands = this.getAll();
            commands.forEach(this.executeCommand);
        },

        disableAll: function () {
            var commands = this.getAll();
            commands.forEach(this.undoCommand);
        },

        executeCommand: function (command) {
            command.execute();
        },

        undoCommand: function (command) {
            command.undo();
        },

        getAll: function () {
            //pass this.commands in as the starting
            //value then add all the groups commands
            return this.groups.reduce(this.getCommandsFromGroup, this.commands);
        },

        getCommandsFromGroup: function (all, group) {
            return all.concat(group.getAll());
        },

        createGroup: function () {
            /*
             * consider better names?
             * subMap
             * childMap
             * maybe group is fine?
             */
            var group = new EventMap();
            this.groups.push(group);
            return group;
        },

        removeGroup: function (group) {
            group.disableAll();
            var groupIndex = this.groups.indexOf(group);
            this.groups.splice(groupIndex, 1);
        },

        typeStringToArray: function (types) {
            return types.split(/\s/);
        }
    });

    function Loader(request) {
        this.request = request;
        this.data = undefined;
    }
    Object.assign(Loader.prototype, {
        load: function () {
            var loadExecutor = this.loadExecutor.bind(this);
            return new Promise(loadExecutor);
        },

        loadExecutor: function (resolve, reject) {
            reject(new Error("Don't directly use the Loader Object"));
        }
    });

    function XMLHttpLoader(request) {
        Loader.call(this, request);
        this.url = request.url;
        this.responseType = request.responseType;
        this.method = request.method || "GET";
        this.postData = request.data;
    }
    XMLHttpLoader.prototype = Object.create(Loader.prototype);

    Object.assign(XMLHttpLoader.prototype, {
        constructor: XMLHttpLoader,

        loadExecutor: function (resolve, reject) {
            this.resolve = resolve;
            this.reject = reject;

            var xmlRequest = new XMLHttpRequest();
            this.xmlRequest = xmlRequest;

            xmlRequest.addEventListener("progress", this.progressHandler.bind(this));
            xmlRequest.addEventListener("load", this.loadHandler.bind(this));
            xmlRequest.addEventListener("error", this.errorHandler.bind(this));
            xmlRequest.addEventListener("abort", this.abortHandler.bind(this));

            xmlRequest.open(this.method, this.url);
            xmlRequest.responseType = this.responseType;
            if (this.postData && this.method === "POST"){
                xmlRequest.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                xmlRequest.send("data="+JSON.stringify(this.postData));
            }
            else {
                xmlRequest.send();
            }
        },

        progressHandler: function (event) {
            if (event.lengthComputable) {
                var percent = event.loaded / event.total;
            }
        },

        loadHandler: function (event) {
            this.data = this.xmlRequest.response;
            this.resolve(this);
        },

        errorHandler: function (event) {
            this.reject(event);
        },

        abortHandler: function (event) {
            this.reject(event);
        }
    });

    function TextLoader(request) {
        XMLHttpLoader.call(this, request);
        this.responseType = "text";
    }
    TextLoader.prototype = Object.create(XMLHttpLoader.prototype);

    Object.assign(TextLoader.prototype, {
        constructor: TextLoader
    });

    function ArrayBufferLoader(request) {
        XMLHttpLoader.call(this, request);
        this.responseType = "arraybuffer";
    }
    ArrayBufferLoader.prototype = Object.create(XMLHttpLoader.prototype);

    Object.assign(ArrayBufferLoader.prototype, {
        constructor: ArrayBufferLoader
    });

    function BlobLoader(request) {
        XMLHttpLoader.call(this, request);
        this.responseType = "blob";
    }
    BlobLoader.prototype = Object.create(XMLHttpLoader.prototype);

    Object.assign(BlobLoader.prototype, {
        constructor: BlobLoader
    });

    function CssLoader(request) {
        Loader.call(this, request);
        this.url = this.request.url;
    }
    CssLoader.prototype = Object.create(Loader.prototype);

    Object.assign(CssLoader.prototype, {
        constructor: CssLoader,

        loadExecutor: function (resolve, reject) {
            this.resolve = resolve;
            this.reject = reject;

            var link = document.createElement("link");
            this.link = link;
            link.addEventListener("load", this.loadHandler.bind(this));
            link.addEventListener("error", this.errorHandler.bind(this));

            link.rel = "stylesheet";
            link.type = "text/css";
            link.href = this.url;

            var head = document.getElementsByTagName("head")[0];
            head.appendChild(link);
        },

        loadHandler: function (event) {
            this.data = this.link;
            this.resolve(this);
        },

        errorHandler: function (event) {
            this.reject(new Error("failed to load css file" + this.url));
        }
    });

    function DocumentLoader(request) {
        XMLHttpLoader.call(this, request);
        this.responseType = "document";
    }
    DocumentLoader.prototype = Object.create(XMLHttpLoader.prototype);

    Object.assign(DocumentLoader.prototype, {
        constructor: DocumentLoader
    });

    function ImageLoader(request) {
        Loader.call(this, request);
        this.url = this.request.url;
    }
    ImageLoader.prototype = Object.create(Loader.prototype);

    Object.assign(ImageLoader.prototype, {
        constructor: ImageLoader,

        loadExecutor: function (resolve, reject) {
            this.resolve = resolve;
            this.reject = reject;

            var image = new Image();
            image.addEventListener("load", this.loadHandler.bind(this));
            image.addEventListener("error", this.errorHandler.bind(this));

            image.crossOrigin = "Anonymous";
            image.src = this.url;
        },

        loadHandler: function (event) {
            this.data = event.currentTarget;
            this.resolve(this);
        },

        errorHandler: function (event) {
            this.reject(new Error("failed to load image" + this.url));
        }
    });

    function JSONLoader(request) {
        XMLHttpLoader.call(this, request);
        this.responseType = "json";
    }
    JSONLoader.prototype = Object.create(XMLHttpLoader.prototype);

    Object.assign(JSONLoader.prototype, {
        constructor: JSONLoader,

        loadHandler: function (event) {
            this.data = this.xmlRequest.response;

            //the json responseType is not supported everywhere
            //in that case parse the text response as JSON
            if (this.xmlRequest.responseType != "json") {
                this.data = JSON.parse(this.xmlRequest.responseText);
            }

            this.resolve(this);
        }
    });

    function ParallelLoader(urlModifiers) {
        //TODO should this extend Loader?
        this.urlModifiers = urlModifiers || [];
        this.typeToLoaderMap = {};
        this.addTypes(this.defaultMap);
    }
    Object.assign(ParallelLoader.prototype, {
        defaultMap: {
            "ajax": XMLHttpLoader,
            "text": TextLoader,
            "json": JSONLoader,
            "document": DocumentLoader,
            "arrayBuffer": ArrayBufferLoader,
            "blob": BlobLoader,
            "image": ImageLoader,
            "css": CssLoader
        },

        load: function (assetRequests) {
            var loaders = assetRequests.map(this.getLoader.bind(this));

            var loadedAssetsByName = Promise.all(loaders.map(this.startLoading)).then(this.buildAssetMapFromLoaders.bind(this));

            return loadedAssetsByName;
        },

        buildAssetMapFromLoaders: function (loaders) {
            return loaders.reduce(this.addLoaderAssetToObject, {});
        },

        addLoaderAssetToObject: function (object, loader) {
            var name = loader.request.name;
            var asset = loader.data;
            object[name] = asset;
            return object;
        },

        startLoading: function (loader) {
            return loader.load();
        },

        addTypes: function (typeMap) {
            Object.assign(this.typeToLoaderMap, typeMap);
        },

        getLoader: function (assetData) {
            var type = assetData.type;
            this.urlModifiers.forEach(this.applyModifier.bind(this, assetData));

            var loaderClass = this.getLoaderByType(type);
            return new loaderClass(assetData);
        },

        applyModifier: function (assetData, modifier) {
            assetData.url = modifier(assetData.url);
        },

        getLoaderByType: function (type) {
            if (!this.typeToLoaderMap.hasOwnProperty(type)) {
                throw new Error("LoaderFactory Error: No Loader for type " + type);
            }
            return this.typeToLoaderMap[type];
        }
    });

    function Container(eventDispatcher, width, height, parentContainerId, productElementId) {
        this.eventDispatcher = eventDispatcher;
        this.maxWidth = width;
        this.maxHeight = height;

        this.parentContainerId = parentContainerId;
        this.productElementId = productElementId;

        this.margin = 10;

        this.resizingContainer = this.getParentElement();
        this.resizingContainer.style.position = "relative";

        this.scalingContainer = this.getProductContainer();

        this.resizingContainer.appendChild(this.scalingContainer);

        this.sizeContainer();
    }
    Object.assign(Container.prototype, {
        getParentElement: function () {
            var element = document.getElementById(this.parentContainerId);
            return element;
        },

        getProductContainer: function () {
            var element = document.createElement("div");
            element.id = this.productElementId;
            return element;
        },

        sizeContainer: function () {
            this.resizingContainer.style.height = this.maxHeight + "px";
            this.resizingContainer.style.width = this.maxWidth + "px";

            this.scalingContainer.style.height = this.maxHeight + "px";
            this.scalingContainer.style.width = this.maxWidth + "px";
            this.scalingContainer.style.transformOrigin = "0 0";
            this.scalingContainer.style["-webkit-transform-origin"] = "0 0";
        }
    });

    function ResizingContainer() {
        Container.apply(this, arguments);

        this.listenForResize();
    }
    ResizingContainer.prototype = Object.create(Container.prototype);

    Object.assign(ResizingContainer.prototype, {
        constructor: ResizingContainer,

        listenForResize: function () {
            this.resizeHandler();
            window.addEventListener("resize", this.resizeHandler.bind(this));
        },

        resizeHandler: function (event) {
            var sizeInfo = this.resizeContainer();

            var resizeEvent = {
                type: "containerResize",
                target: this,
                width: sizeInfo.width,
                height: sizeInfo.height,
                scale: 1
            };

            this.postResize(sizeInfo, resizeEvent);

            this.eventDispatcher.dispatchEvent(resizeEvent);
        },

        postResize: function (sizeInfo, resizeEvent) {
            //probably just for subclasses
        },

        resizeContainer: function () {
            //Scale to fit the window or the container
            //
            //TODO reword this comment
            //As we resize the productContainer the parent of productContainer
            //shinks so we need to resize the productContainer to the maximum
            //and then scale to fit
            this.resizingContainer.style.height = this.maxHeight + "px";
            this.resizingContainer.style.width = this.maxWidth + "px";

            var resizingParent = this.resizingContainer.parentNode;

            var heighToScaleTo = Math.min(resizingParent.offsetHeight, window.innerHeight - this.margin);
            heighToScaleTo = Math.min(this.maxHeight, heighToScaleTo);

            var widthToScaleTo = Math.min(resizingParent.offsetWidth, window.innerWidth - this.margin);
            widthToScaleTo = Math.min(this.maxWidth, widthToScaleTo);

            var scale = Math.min(widthToScaleTo / this.maxWidth, heighToScaleTo / this.maxHeight);

            var newWidth = this.maxWidth * scale;
            var newHeight = this.maxHeight * scale;

            this.resizingContainer.style.width = newWidth + "px";
            this.resizingContainer.style.height = newHeight + "px";

            return {
                width: newWidth,
                height: newHeight,
                amountToScale: scale
            };
        }
    });

    function ScalingContainer() {
        ResizingContainer.apply(this, arguments);
    }
    ScalingContainer.prototype = Object.create(ResizingContainer.prototype);

    Object.assign(ScalingContainer.prototype, {
        constructor: ScalingContainer,

        postResize: function (sizeInfo, resizeEvent) {
            this.scaleContainer(sizeInfo.amountToScale);
            resizeEvent.scale = sizeInfo.amountToScale;
        },

        scaleContainer: function (scale) {
            this.scalingContainer.style.transform = "scale(" + scale + "," + scale + ")";
            this.scalingContainer.style["-webkit-transform"] = "scale(" + scale + "," + scale + ")";
        }
    });

    //TODO generate this file with a grunt template for the win
    //events

    exports.EventDispatcher = EventDispatcher;
    exports.EventMap = EventMap;
    exports.AddEventCommand = AddEventCommand;
    exports.Loader = Loader;
    exports.XMLHttpLoader = XMLHttpLoader;
    exports.TextLoader = TextLoader;
    exports.ArrayBufferLoader = ArrayBufferLoader;
    exports.BlobLoader = BlobLoader;
    exports.CssLoader = CssLoader;
    exports.DocumentLoader = DocumentLoader;
    exports.ImageLoader = ImageLoader;
    exports.JSONLoader = JSONLoader;
    exports.ParallelLoader = ParallelLoader;
    exports.Container = Container;
    exports.ResizingContainer = ResizingContainer;
    exports.ScalingContainer = ScalingContainer;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
